export function hasVerticalScrollbar() {
    return document.documentElement.scrollHeight > window.innerHeight;
}
//# sourceMappingURL=hasVerticalScrollbar.js.map